import {
	GET_QNA_PAGE_REQUEST,
	GET_QNA_PAGE_SUCCESS,
	GET_QNA_PAGE_ERROR,
	RESET_QNA_PAGE_DATA,
	QNA_INPUT_TEXT_SUBMIT_REQUEST,
	QNA_INPUT_TEXT_SUBMIT_SUCCESS,
	QNA_INPUT_TEXT_SUBMIT_ERROR,
	QNA_INPUT_TEXT_RESET,
	ANSWER_DELETE_REQUEST,
	ANSWER_DELETE_SUCCESS,
	ANSWER_DELETE_ERROR,
	RESET_ANSWER_DELETE,
	GET_ALL_ANSWER_PAGE_REQUEST,
	GET_ALL_ANSWER_PAGE_SUCCESS,
	GET_ALL_ANSWER_PAGE_ERROR,
	RESET_ALL_ANSWER_PAGE_DATA,
	SHOW_MORE_QNA_REQUEST,
	SHOW_MORE_QNA_SUCCESS,
	SHOW_MORE_QNA_ERROR,
	SEARCH_TEXT_QNA_REQUEST,
	SEARCH_TEXT_QNA_SUCCESS,
	SEARCH_TEXT_QNA_ERROR,
	SEARCH_TEXT_QNA_RESET
} from 'actions/productQNAActions';
import { INIT, LOADING, SUCCESS, ERROR } from 'utils/asyncStatusHelper';

const defaultState = {
	asyncStatus: INIT
};

function commonReducer(state = defaultState, action = {}, INITIALIZE, COMPLETE, FAILED, RESET, override = false) {
	let storeObj = {};
	switch (action.type) {
		case INITIALIZE:
			storeObj = { asyncStatus: LOADING };
			break;
		case COMPLETE:
			storeObj = { asyncStatus: SUCCESS, data: action.data };
			break;
		case FAILED:
			storeObj = { asyncStatus: ERROR, error: action.error };
			break;
		case RESET:
			override = false;
			storeObj = defaultState;
			break;
		default:
			override = false;
			storeObj = state;
			break;
	}
	if (override) {
		return Object.assign({}, state, storeObj);
	}
	return storeObj;
}

export function qnaPageReducer(state = defaultState, action = {}) {
	return commonReducer(
		state,
		action,
		GET_QNA_PAGE_REQUEST,
		GET_QNA_PAGE_SUCCESS,
		GET_QNA_PAGE_ERROR,
		RESET_QNA_PAGE_DATA
	);
}

export function inputValueReducer(state = defaultState, action = {}) {
	return commonReducer(
		state,
		action,
		QNA_INPUT_TEXT_SUBMIT_REQUEST,
		QNA_INPUT_TEXT_SUBMIT_SUCCESS,
		QNA_INPUT_TEXT_SUBMIT_ERROR,
		QNA_INPUT_TEXT_RESET
	);
}

export function deleteAnswerReducer(state = defaultState, action = {}) {
	return commonReducer(
		state,
		action,
		ANSWER_DELETE_REQUEST,
		ANSWER_DELETE_SUCCESS,
		ANSWER_DELETE_ERROR,
		RESET_ANSWER_DELETE
	);
}

export function allAnswerReducer(state = defaultState, action = {}) {
	return commonReducer(
		state,
		action,
		GET_ALL_ANSWER_PAGE_REQUEST,
		GET_ALL_ANSWER_PAGE_SUCCESS,
		GET_ALL_ANSWER_PAGE_ERROR,
		RESET_ALL_ANSWER_PAGE_DATA
	);
}

export function moreContentReducer(state = defaultState, action = {}) {
	return commonReducer(state, action, SHOW_MORE_QNA_REQUEST, SHOW_MORE_QNA_SUCCESS, SHOW_MORE_QNA_ERROR, null, true);
}

export function searchQnATextReducer(state = defaultState, action = {}) {
	return commonReducer(
		state,
		action,
		SEARCH_TEXT_QNA_REQUEST,
		SEARCH_TEXT_QNA_SUCCESS,
		SEARCH_TEXT_QNA_ERROR,
		SEARCH_TEXT_QNA_RESET,
		true
	);
}
